import React from "react";
import SbEditable from "storyblok-react";
import classnames from "classnames";
import Image from "@/components/Image/image";
import styles from "./steps.module.scss";
import type { StepsStoryblok } from "./types";

interface Props {
  blok: StepsStoryblok;
}

const Steps = ({ blok }: Props) => {
  const steps = Array.isArray(blok.steps) ? blok.steps : [];
  const desktopImagePosition = blok.desktop_image_position || "right";
  const mobileImagePosition = blok.mobile_image_position || "bottom";
  const contentAlignment = blok.content_alignment || "center";
  const imageSize = blok.image_size || "large";
  const imageShape = blok.image_shape || "square";

  return (
    // @ts-expect-error
    <SbEditable content={blok}>
      <section className={styles.steps}>
        {blok.background_image?.filename ? (
          <div className={styles.stepsBgImage}>
            <Image
              filename={blok.background_image.filename}
              alt=""
              className={styles.imageFillParent}
            />
          </div>
        ) : null}
        <div className={styles.stepsBgOverlay} />
        <div
          className={classnames(styles.stepsInner, {
            [styles.stepsInnerImageTopMobile]: mobileImagePosition === "top",
            [styles.stepsInnerImageLeft]: desktopImagePosition === "left",
            [styles.stepsInnerAlignStart]: contentAlignment === "start",
            [styles.stepsInnerAlignEnd]: contentAlignment === "end",
          })}
        >
          <div className={styles.stepsContent}>
            {blok.heading || blok.subheading ? (
              <div className={styles.stepsIntro}>
                {blok.heading ? (
                  <h2 className={styles.stepsHeading}>{blok.heading}</h2>
                ) : null}
                {blok.subheading ? (
                  <p className={styles.stepsSubheading}>{blok.subheading}</p>
                ) : null}
              </div>
            ) : null}
            <div className={styles.stepsList}>
              {steps.length
                ? steps.map((step, index) => (
                    <div key={step._uid} className={styles.stepItem}>
                      <span className={styles.stepNumber}>
                        {step.number || String(index + 1).padStart(2, "0")}
                      </span>
                      {step.title ? (
                        <h3 className={styles.stepTitle}>{step.title}</h3>
                      ) : null}
                      {step.description ? (
                        <p className={styles.stepDescription}>
                          {step.description}
                        </p>
                      ) : null}
                    </div>
                  ))
                : null}
            </div>
          </div>
          {blok.side_image?.filename ? (
            <div
              className={classnames(styles.stepsImage, {
                [styles.stepsImageStandard]: imageSize === "standard",
                [styles.stepsImagePortrait]: imageShape === "portrait",
                [styles.stepsImageLandscape]: imageShape === "landscape",
              })}
            >
              <Image
                filename={blok.side_image.filename}
                alt={blok.side_image.alt || ""}
                className={styles.imageFillParent}
                sizes="(min-width: 1024px) 685px, calc(100vw - 48px)"
              />
            </div>
          ) : null}
        </div>
      </section>
    </SbEditable>
  );
};

export default Steps;
